
import { FormStyle, getLocaleMonthNames, TranslationWidth } from '@angular/common';
import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'month-view',
    templateUrl: './month-view.component.html',
    styleUrls: ['month-view.component.scss'],
    standalone: false
})
export class MonthViewComponent implements OnChanges {

  @Input()
  public model: NgbDateStruct;

  @Output()
  public modelChange = new EventEmitter<NgbDateStruct>();

  public today: NgbDateStruct;

  public currentYear: number;

  public isYearView: boolean = false;
  public increment: number = 0;
  public months: readonly string[]; // angular upgrade could cause a problem

  constructor(@Inject(LOCALE_ID) private locale: string) {
    this.today = this.getTodayNgbDate();
    // Angular upgrade possible error 
    this.months = getLocaleMonthNames(this.locale, FormStyle.Standalone, TranslationWidth.Abbreviated);
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (!this.model) {
      this.model = {} as NgbDateStruct
    }

    const year = this.model.year || this.today.year;
    this.currentYear = year;
    this.increment = (year - year % 10) - 1;
  }

  public toggleMonthYearView($event: any) {
    $event.stopPropagation();
    this.isYearView = !this.isYearView;
  }

  public selectMonthOrYear($event: any, index: number) {
    if (this.isYearView) {
      $event.stopPropagation();

      this.currentYear = index + this.increment;

      this.isYearView = false;
    }
    else {
      const ngbDateModel: NgbDateStruct = {
        day: 1,
        month: index + 1,
        year: this.currentYear
      };

      this.modelChange.emit(ngbDateModel);
    }
  }

  public addYear($event: any, increment: number) {
    $event.stopPropagation();
    this.currentYear = this.isYearView ? this.currentYear + 10 * increment : this.currentYear + increment;
    this.increment = (this.currentYear - this.currentYear % 10) - 1;
  }

  private getTodayNgbDate(): NgbDateStruct {
    const nativeToday = new Date();
    return {
      day: nativeToday.getDate(),
      month: nativeToday.getMonth() + 1,
      year: nativeToday.getFullYear()
    } as NgbDateStruct;
  }
}


